<template>
    <multi-select v-model="selected" @selected="$emit('selected', $event)" :placeholder="placeholder" @input="$emit('input', $event)" option-name="display_name" :search-by="['email', 'display_name']" :options="users" :prevent-hit="preventHit">
        <template v-slot:result="{ item }">
            <slot name="result" :item="item">
                <strong>{{ item.is_pending ? 'Pending member' : item.display_name }}</strong> <small>{{ item.email }}</small>
            </slot>
        </template>
        <template v-slot:selected="{ item }">
            <slot name="selected" :item="item">
                {{ item.is_pending ? item.email : item.display_name }}
            </slot>
        </template>
    </multi-select>
</template>
<script type="text/babel">

import AbstractSearch from './AbstractSearch'
import MultiSelect from './MultiSelect'

export default {
    extends: AbstractSearch,

    props: {
        users: {
            required: true,
            type: Array
        },

        value: {
            required: false,
            type: Array
        },

        placeholder: {
            required: false,
            type: String,
            default: 'Search for people...'
        },

        preventHit: {
            type: Function,
            default: null
        }
    },

    data () {
        return {
            selected: this.value
        }
    },

    components: {
        MultiSelect
    }
}
</script>
